import { handleError } from "@/utils/errorHandler";

class TokenRefreshService {
  private static instance: TokenRefreshService;
  private timeoutId: NodeJS.Timeout | null = null;
  private isRefreshing = false;

  static getInstance(): TokenRefreshService {
    if (!TokenRefreshService.instance) {
      TokenRefreshService.instance = new TokenRefreshService();
    }
    return TokenRefreshService.instance;
  }

  async scheduleRefresh(onRefresh: () => Promise<void>) {
    this.clearSchedule();

    try {
      const response = await fetch('/api/token-info');
      const { expiresAt } = await response.json();
      
      if (!expiresAt) return;

      const now = Date.now();
      const refreshTime = expiresAt - 60000; // 1 minute before expiry
      const delay = refreshTime - now;

      if (delay > 0) {
        this.timeoutId = setTimeout(async () => {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            try {
              await fetch('/api/refresh-token', { method: 'POST' });
              await onRefresh();
              this.scheduleRefresh(onRefresh); // Schedule next refresh
            } finally {
              this.isRefreshing = false;
            }
          }
        }, delay);
      }
    } catch (error) {
      handleError(error, { component: "TokenRefreshService", action: "scheduleRefresh" });
    }
  }

  clearSchedule() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  stop() {
    this.clearSchedule();
    this.isRefreshing = false;
    TokenRefreshService.instance = undefined as any;
  }
}

export default TokenRefreshService;